import React from 'react'
import { useSelector } from 'react-redux'

import DashboardWrapper from '../dashboard/DashboardWrapper'
import SuccessRateFilter from './components/SuccessRateFilter'
import GroupWrapper from '../dashboard/components/GroupWrapper'

import ChartsExport from './charts/ChartsExport'

import SuccessRateCharts from './charts/index'

import Flex from '../../../components/layouts/Flex'

const SuccessRate = () => {
  const download = useSelector((state) => state.dashboard.download)
  return (
    <DashboardWrapper>
      <div>
        <GroupWrapper title="Report Filters">
          <Flex
            direction="column"
            padding="0 1rem 1rem 0"
            width="100%"
            gap="1rem"
            height="28vh"
            justify="center"
            items="center"
          >
            <SuccessRateFilter />
          </Flex>
        </GroupWrapper>
      </div>
      <div className="report-container">
        <SuccessRateCharts />

        {download === 'success-rate-pdf' && <ChartsExport />}
      </div>
    </DashboardWrapper>
  )
}

export default SuccessRate
